import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class HumanCapitalPayrollPeriodActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Hr/PayrollPeriod/PayrollPeriodBrowser")
	}

	render() {
		return (
			<Activity 
				name="HumanCapitalPayrollPeriod"
				RenderedComponent={this.RenderedComponent}
				context="HumanCapitalPayrollPeriod"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(HumanCapitalPayrollPeriodActivity)
